
import React, { useState } from 'react';
import Slider, { Settings as CarouselSettings } from 'react-slick';
import './styles.scss';
 import CarouselModal from './CarouselModal';
interface Props {
  images: any;
  slideShapes:string;
  slides_to_show:string;
   banner_top_shadow: string;
  banner_top_shadow_opacity: string;
  banner_bottom_shadow: string;
  banner_bottom_shadow_opacity: string;
  paragraphId:string;
}
let Modaldata:any;

const Carousel: React.FC<Props> = ({ images,slideShapes,slides_to_show,paragraphId,banner_top_shadow,banner_top_shadow_opacity,banner_bottom_shadow,banner_bottom_shadow_opacity}) => {
  console.log("slides_to_show",slides_to_show)
  const settings: CarouselSettings = {

    slidesToShow: ((slides_to_show) ? parseInt(slides_to_show) : 4),
    slidesToScroll: 1,
		infinite: false,
    focusOnSelect: true,
    dots: true,
    className: 'item',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };
  const [isImageModal, setImageModal] = useState(false);
	

	

  return (
    <div className="giveawayy-slide-items">
   {<style dangerouslySetInnerHTML={{__html: `.bottom-slides .card-inner-`+parseInt(paragraphId)+`::before {
        background-image: linear-gradient(to top, transparent, `+banner_top_shadow+`);
        opacity: `+banner_top_shadow_opacity+`;
      }
              .bottom-slides .card-inner-`+parseInt(paragraphId)+`::after {
        background-image: linear-gradient(to bottom, transparent, `+banner_bottom_shadow+`);
        opacity: `+banner_bottom_shadow_opacity+`;
      }
      @media (min-width: 1200px) {
        .bottom-slides .card-inner-`+parseInt(paragraphId)+`::after {
          height: 350px;
        }
      }
      @media (min-width: 320px) and (max-width: 767px) {
        .bottom-slides .card-inner-`+parseInt(paragraphId)+`::after {
          height: 250px;
        }` }} /> }

  
      <div className="container">
        <div className="row">
          <div className="col-12">
					
            <div className={"models-slider cols-3 slick-initialized slick-slider slick-dotted "+slideShapes}>
              <Slider {...settings}>
								{images.map((image:any, i:any) => (
                  <React.Fragment>
									<div>
									<a className="" onClick={(event)=> {
                    event.preventDefault();
                    Modaldata=image;setImageModal(true);
                  }} href="/"><img src={image.img} alt="" /></a>
									<p className="thumb_desc">{image.desc}</p>
									</div>
                  
                  </React.Fragment>
								))}
              </Slider>
              <CarouselModal
                    show={isImageModal}
                    img={(Modaldata)?Modaldata.img:""}
                    description={(Modaldata)?Modaldata.desc:""}
                    onHide={() => setImageModal(false)}
                    onClose={() => setImageModal(false)}
                  />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Carousel;
